import React, { Component, useEffect, useState } from "react";
import {
  StyleSheet,
  View,
  Text,
  TouchableOpacity,
  ScrollView,
  FlatList,
  Animated,
  ImageBackground,
} from "react-native";
import { StackActions, NavigationActions } from "react-navigation";
import { EventRegister } from "react-native-event-listeners";
import Toast from "react-native-tiny-toast";
import Icon from "react-native-vector-icons/FontAwesome";

import {
  getAluno,
  removerTelefone,
  enviarCodigoSMS,
} from "../../services/aluno-service";
import styles from "./styles";
import Loading from "../../components/Loading";
import moment from "moment";

const CardCurso = (props) => {
  useEffect(() => {
    Animated.timing(_animated, {
      toValue: 1,
      duration: 300,
      useNativeDriver: true,
    }).start();
  });
  const _animated = new Animated.Value(0);
  const curso = props.curso.item;
  const rowStyles = [styles.personalData, { opacity: _animated }];

  return (
    <Animated.View style={rowStyles}>
      <View style={styles.header}>
        <Text style={[styles.textHeader, { marginTop: 0 }]}>{curso.nome}</Text>
      </View>
      <View style={styles.body}>
        <Text style={[styles.dataProperty, { marginTop: 0 }]}>
          CARGA HORÁRIA:
        </Text>
        <Text style={[styles.dataValue, { marginTop: 0 }]}>
          {curso.carga_horaria}
        </Text>

        <Text style={[styles.dataProperty, { marginTop: 0 }]}>
          {curso.data_conclusao ? "CONCLUÍDO EM:" : "CURSANDO"}
        </Text>
        {curso.data_conclusao && (
          <Text style={[styles.dataValue, { marginTop: 0 }]}>
            {curso.data_conclusao}
          </Text>
        )}
      </View>
    </Animated.View>
  );
};

const Cursos = () => {
  const [aluno, setAluno] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const carregarAluno = async () => {
      setAluno(await getAluno());
    };

    carregarAluno();
  }, []);

  return (
    <ImageBackground
      source={require("../../../resources/imgs/bg.jpg")}
      style={[styles.container]}
      imageStyle={styles.imageContainer}
    >
      {loading && <Loading />}
      <FlatList
        style={{ height: 300 }}
        data={aluno.cursos}
        keyExtractor={(curso) => String(curso.id)}
        showsVerticalScrollIndicator={false}
        renderItem={(curso) => <CardCurso key={curso.id} curso={curso} />}
      />
    </ImageBackground>
  );
};

Cursos.navigationOptions = ({ navigation }) => {
  return {
    headerStyle: {
      backgroundColor: "#0F0F0F",
    },
    headerTitleStyle: {
      color: "#FFF",
    },
    headerLeft: () => (
      <TouchableOpacity
        onPress={() => {
          navigation.openDrawer();
        }}
      >
        <Icon
          style={styles.iconHeaderLeft}
          name="reorder"
          size={30}
          color="#F1F1F1"
        />
      </TouchableOpacity>
    ),
    headerRight: () => (
      <TouchableOpacity
        onPress={() => {
          EventRegister.emit("reload", "it works!!!");

          Toast.show("Atualizado");
        }}
      >
        <Icon
          style={styles.iconBarRight}
          name="refresh"
          size={20}
          color="#F1F1F1"
        />
      </TouchableOpacity>
    ),
  };
};

export default Cursos;
